// GO4S Design System — couleurs de graphiques résolues depuis les tokens CSS.
// Chart.js / canvas ne comprennent pas var() : on résout en valeurs réelles.
// Source unique pour la palette (--ds-chart-1..10), le trait de séparation
// (--ds-chart-stroke) et la résolution de tokens arbitraires — s'adapte au
// thème (clair/sombre) puisque les tokens sont remappés.

// Palette theme-aware : n couleurs cyclées sur --ds-chart-1..10.
export function chartPalette(n = 10) {
  const cs = getComputedStyle(document.documentElement);
  return Array.from({ length: n }, (_, i) =>
    cs.getPropertyValue(`--ds-chart-${(i % 10) + 1}`).trim() || "#888"
  );
}

// Couleur de séparation des segments (donut/pie) — suit la surface.
export function chartStroke() {
  return (
    getComputedStyle(document.documentElement)
      .getPropertyValue("--ds-chart-stroke")
      .trim() || "#fff"
  );
}

// Résout les occurrences de `var(--x)` d'une couleur en valeurs réelles.
// Gère couleur unique ou tableau ; laisse les couleurs littérales inchangées.
export function resolveCssColor(value) {
  if (Array.isArray(value)) return value.map((v) => resolveCssColor(v));
  if (typeof value !== "string") return value;
  const cs = getComputedStyle(document.documentElement);
  return value.replace(
    /var\((--[\w-]+)\)/g,
    (raw, name) => cs.getPropertyValue(name).trim() || raw
  );
}
